import React from 'react';
import { withRouter, useHistory } from 'react-router-dom';
import _ from 'lodash'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import {Chip, Slide, TextField, LinearProgress, withStyles, makeStyles, Paper, Box} from '@material-ui/core'
import {Skeleton, Alert} from '@material-ui/lab'
import { firestore } from '../../../../firebase/firebase'
import firebase from 'firebase/compat/app'
import DeleteIcon from '@material-ui/icons/Delete';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useAuth } from '../../../../providers/AuthContext';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import ThumbDownIcon from '@material-ui/icons/ThumbDown';
import TimerIcon from '@material-ui/icons/Timer';
import PrintIcon from '@material-ui/icons/Print';
import moment from 'moment';
import QRCode from 'qrcode.react';

const useStyles = makeStyles((theme) => ({
    headerCard: {
        borderRadius: '8px',
        marginBottom:'-80px',
        overflow: 'hidden',
    },
    statusBar: {
        background: '#fbbf24',
        color: 'black',
        padding: '8px 24px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        fontSize: '14px',
        fontWeight: 500,
    },
    statusBarApproved: {
        background: '#10b981',
    },
    statusBarPayrolled: {
        background: '#3b82f6',
    },
    mainContent: {
        padding: '24px 32px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            gap: '20px',
            padding: '16px',
        },
    },
    employeeSection: {
        flex: 1,
    },
    employeeName: {
        fontSize: '28px',
        fontWeight: 600,
        color: theme.palette.secondary.main,
        marginBottom: '8px',
    },
    metaInfo: {
        display: 'flex',
        gap: '24px',
        alignItems: 'center',
        flexWrap: 'wrap',
    },
    metaItem: {
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
    },
    metaLabel: {
        fontSize: '12px',
        color: theme.palette.secondary.light,
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
    },
    metaValue: {
        fontSize: '14px',
        color: theme.palette.secondary.dark,
        fontWeight: 500,
    },
    actionsSection: {
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            justifyContent: 'space-between',
        },
    },
    btnGroup: {
        display: 'flex',
        gap: '8px',
        flexWrap: 'wrap',
    },
    btn: {
        padding: '10px 18px',
        border: '1px solid transparent',
        borderRadius: '6px',
        fontSize: '14px',
        fontWeight: 500,
        cursor: 'pointer',
        transition: 'all 0.2s',
        textTransform: 'none',
        minWidth: 'auto',
    },
    btnOutline: {
        background: 'white',
        borderColor: '#d1d5db',
        color: '#374151',
        '&:hover': {
            background: '#f9fafb',
            borderColor: '#9ca3af',
        },
    },
    btnPrimary: {
        background: '#3b82f6',
        color: 'white',
        '&:hover': {
            background: '#2563eb',
        },
    },
    btnSuccess: {
        background: '#10b981',
        color: 'white',
        '&:hover': {
            background: '#059669',
        },
    },
    btnDanger: {
        background: '#ef4444',
        color: 'white',
        '&:hover': {
            background: '#dc2626',
        },
        '&:disabled': {
            background: '#fca5a5',
            color: 'white',
        },
    },
    qrSection: {
        width: '64px',
        height: '64px',
        background: '#f3f4f6',
        borderRadius: '8px',
        marginLeft: '24px',
        padding: '8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        [theme.breakpoints.down('sm')]: {
            marginLeft: 0,
        },
    },
    warningBanner: {
        background: '#fef3c7',
        border: '1px solid #fbbf24',
        borderRadius: '6px',
        padding: '12px 16px',
        marginTop: '16px',
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
    },
    warningText: {
        color: '#92400e',
        fontSize: '14px',
        fontWeight: 500,
        flex: 1,
    },
}));

const BorderLinearProgress = withStyles((theme) => ({
    root: {
      height: 10,
      borderRadius: 5,
      border: '1px solid white',
    },
    colorPrimary: {
      backgroundColor: 'grey',
    },
    bar: {
      borderRadius: 5,
      backgroundColor: '#FFBF00',
    },
  }))(LinearProgress);

const TimesheetHeader = (props) => {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const [splitOpen, setSplitOpen] = React.useState(false);
    const [approveOpen, setApproveOpen] = React.useState(false);
    const [approvePayrollOpen, setApprovePayrollOpen] = React.useState(false);
    const [alertOpen, setAlertOpen] = React.useState(false);
    const [setting, setSetting] = React.useState('')
    const [splitting, setSplitting] = React.useState(false)
    const [splitProgress, setSplitProgress] = React.useState(0)
    const [splitDescription, setSplitDescription] = React.useState('')
    const [deleteReason, setDeleteReason] = React.useState('')
    const { roles, currentUser, userInfo } = useAuth();
    const history = useHistory();
    const path = "/dashboard/reporting/timesheets/printing/?docId=" + props.timesheetData.docId
    
    const handlePrint = () => {
        firestore.collection('timesheets').doc(props.timesheetData.docId).update({ 'timesheetStatus': 'printed' })
        history.push(path)
    }
    
    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleCloseSplit = () => {
        setSplitOpen(false);
    };

    const handleOpenSplit = () => {
        setSplitOpen(true)
    }
    
    const handleAlert = (style) =>{
        setSetting(style)
        setAlertOpen(true);
        setTimeout(() => {setAlertOpen(false);setSetting('');}, 4 * 1000);
    }

    const handleClickApproveOpen = () => {
        setApproveOpen(true);
    };

    const handleClickApproveClose = () => {
        setApproveOpen(false);
    };

    const handleClickApprovePayrollOpen = () => {
        setApprovePayrollOpen(true);
    };

    const handleClickApprovePayrollClose = () => {
        setApprovePayrollOpen(false);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleDeleteClick = () => {
        firestore.collection('notifications').add({
            'type': 'delete',
            'message': 'Timesheet #'+props.timesheetData.timesheetID+' has been deleted by '+userInfo.firstName + ' ' + userInfo.lastName,
            'userEmail': currentUser.email,
            'userName': userInfo.firstName + ' ' + userInfo.lastName,
            'timestamp': new Date(),
            'reason': deleteReason,
        })
        firestore.collection('timesheets').doc(props.timesheetData.docId).delete().then(() => {
            firestore.collection('jobs').where('timesheetID', '==', props.timesheetData.docId).get().then((docs) => docs.forEach((doc) => firestore.collection('jobs').doc(doc.id).delete()))
            firestore.collection('checklists').where('timesheetID', '==', props.timesheetData.docId).get().then((docs) => docs.forEach((doc) => firestore.collection('checklists').doc(doc.id).delete()))
            firestore.collection('deliveries').where('timesheetID', '==', props.timesheetData.docId).get().then((docs) => docs.forEach((doc) => firestore.collection('deliveries').doc(doc.id).delete()))
            firestore.collection('units').where('timesheetID', '==', props.timesheetData.docId).get().then((docs) => docs.forEach((doc) => firestore.collection('units').doc(doc.id).delete().then(() => {
                firestore.collection('defectReports').where('unitId', '==', doc.id).get().then((docs) => docs.forEach((doc) => firestore.collection('defectReports').doc(doc.id).delete()))
            })))
            console.log("Timesheet successfully deleted!");
            handleClose();
            let timesheets = JSON.parse(sessionStorage.getItem('timesheetData'))
            timesheets.length>0 ? timesheets = timesheets.filter((timesheet) => timesheet.docId !== props.timesheetData.docId) : timesheets=[]
            sessionStorage.setItem('timesheetData', JSON.stringify(timesheets))
            props.history.replace({pathname: '/dashboard/reporting/'})
        }).catch((error) => {
            console.error("Error removing timesheet: ", error);
        });
    }

    const handleApproveClick = () => {
        props.updateTimesheetField({ 'approved': true });
        props.setSaveState({...props.saveState, approved: true})
        console.log("Timesheet successfully approved!");
        setApproveOpen(false);
        firestore.collection('timesheets').doc(props.timesheetData.docId)
        .update({
            'approved': true,
            'payrolled': false,
        })
        .then(() => {
            firestore.collection('timesheets').where('approved', '==', false).where('timesheetID', '!=', 0).where('timesheetType', '==', props.timesheetData.timesheetType).orderBy('timesheetID')
            .get()
            .then((querySnapshot) => {
                let data = querySnapshot.docs.map((doc) => doc.data())
                props.setTimesheetLoading(true)
                props.history.push({
                    pathname: '/dashboard/reporting/timesheets',
                    search: "?" + new URLSearchParams({ docId: data[0].docId }).toString(),
                    timesheetList: props.location.timesheetList && props.location.timesheetList.filter((timesheet) => timesheet.docId !== props.timesheetData.docId),
                })
            })
        })
        .catch((e) => {console.log(e);});
        handleAlert()
    }

    const handleApproveClickPayroll = () => {
        props.updateTimesheetField({ 'payrolled': true });
        props.setSaveState({...props.saveState, payrolled: true})
        console.log("Timesheet successfully approved!");
        setApprovePayrollOpen(false);
        firestore.collection('timesheets').doc(props.timesheetData.docId)
        .update({
            'approved': true,
            'payrolled': true,
        })
        .then(() => {
            firestore.collection('timesheets').where('payrolled', '==', false).where('timesheetID', '!=', 0).where('timesheetType', '==', props.timesheetData.timesheetType).orderBy('timesheetID')
            .get()
            .then((querySnapshot) => {
                let data = querySnapshot.docs.map((doc) => doc.data())
                props.setTimesheetLoading(true)
                props.history.push({
                    pathname: '/dashboard/reporting/timesheets',
                    search: "?" + new URLSearchParams({ docId: data[0].docId }).toString(),
                    timesheetList: props.location.timesheetList && props.location.timesheetList.filter((timesheet) => timesheet.docId !== props.timesheetData.docId),
                })
            })
        })
        .catch((e) => {console.log(e);});
        handleAlert()
    }

    const handleUnapproveClick = () => {
        props.updateTimesheetField({ 'approved': false });
        props.setSaveState({...props.saveState, approved: false})
        console.log("Timesheet successfully unapproved!");
        setApproveOpen(false);
        firestore.collection('timesheets').doc(props.timesheetData.docId)
        .update({
            'approved': false,
            'payrolled': false,
        })
        .then(() => {
        })
        .catch((e) => {console.log(e);});
        handleAlert('unapprove')
    }

    const handleUnapproveClickPayroll = () => {
        props.updateTimesheetField({ 'payrolled': false });
        props.setSaveState({...props.saveState, payrolled: false})
        console.log("Timesheet successfully unapproved!");
        setApprovePayrollOpen(false);
        firestore.collection('timesheets').doc(props.timesheetData.docId)
        .update({
            'payrolled': false,
        })
        .then(() => {
        })
        .catch((e) => {console.log(e);});
        handleAlert('unapprove')
    }

    const handleSplitTimesheet = async () => {
        try {
            setSplitting(true)
            setSplitProgress(1);
            console.log("Splitting timesheet");
            setSplitDescription('Copying data to new timesheet...');
            let currentData = props.timesheetData;
            const newTimesheet = {
                ...currentData,
                inTime: moment(currentData.outTime).startOf('day').toDate().valueOf(),
                date: moment(currentData.outTime).startOf('day').toDate().valueOf(),
                docId: '',
                timesheetID: 0,
            };
            setSplitProgress(10);
            setSplitDescription('Selecting a random shard...');
            const shardIndex = Math.floor(Math.random() * 10);
            setSplitProgress(15);
            setSplitDescription('Generating new timesheet ID...');
            await firestore.collection('shards').doc(shardIndex.toString()).update({
                count: firebase.firestore.FieldValue.increment(1)
            });
            setSplitProgress(17);
            const shardDocs = await firestore.collection('shards').get();
            const newID = shardDocs.docs.reduce((shardCount, doc) => shardCount + doc.data().count, 0);
            console.log("New Timesheet ID: ", newID);
            setSplitProgress(20);
            newTimesheet.timesheetID = newID;
            const docRef = await firestore.collection('timesheets').add(newTimesheet);
            setSplitDescription('New Timesheet Created, updating docID...');
            setSplitProgress(25);
            const newDocId = docRef.id;
            await firestore.collection('timesheets').doc(newDocId).update({ 'docId': newDocId });
            setSplitProgress(27);
            newTimesheet.docId = newDocId;
            console.log("New Timesheet DOCID: ", newDocId);
            setSplitProgress(28);
            setSplitDescription('Updating outTime of current timesheet...');
            await firestore.collection('timesheets').doc(currentData.docId).update({ 'outTime': moment(currentData.inTime).endOf('day').toDate().valueOf() });
            console.log("Current Timesheet outTime updated");
            setSplitProgress(30);
            setSplitProgress(50);
            setSplitProgress(60);
            setSplitProgress(70);
            setSplitDescription('Writing notes to timesheets about the split....');

            const notes = [
                {
                    timesheetId: currentData.docId,
                    note: `This timesheet was split into two timesheets, this means it was automatically set to Skip Lunch.\nThe 2nd timesheet is Timesheet #${newTimesheet.timesheetID}`,
                },
                {
                    timesheetId: newTimesheet.docId,
                    note: `This timesheet was split from Timesheet #${currentData.timesheetID}`,
                }
            ];
            setSplitProgress(80);
            for (let note of notes) {
                await firestore.collection('timesheets').doc(note.timesheetId).collection('notes').add({
                    'note': note.note,
                    'timestamp': new Date(),
                    'uid': currentUser.uid,
                });
            }
            setSplitProgress(90);
            console.log("Notes added to timesheets");
            setSplitDescription('Splitting complete!');
            setSplitProgress(100);
            setTimeout(() => {
                props.updateTimesheetField({ 'outTime': moment(currentData.inTime).endOf('day').toDate().valueOf(), 'skipLunch': 'pending' });
                props.confirmSave();
                handleCloseSplit();
                setSplitting(false);
            }, 2000);
            
        } catch (error) {
            console.error("Error splitting timesheet: ", error);
        }
    };

    // Helper function to get status
    const getStatus = () => {
        if (props.timesheetData?.payrolled) return 'Payrolled';
        if (props.timesheetData?.approved) return 'Approved';
        if (props.timesheetData?.submitted) return 'Submitted';
        if (props.timesheetData?.timesheetID) return 'Pending Approval';
        return 'In Progress';
    };

    // Helper function to get status bar class
    const getStatusBarClass = () => {
        if (props.timesheetData?.payrolled) return classes.statusBarPayrolled;
        if (props.timesheetData?.approved) return classes.statusBarApproved;
        return '';
    };

    // Check if user can approve
    const canApprove = props.timesheetData?.approved !== null && 
        ((props.timesheetData?.timesheetType === 'Office' && roles.includes('Approve Office Timesheets')) || 
        (props.timesheetData?.timesheetType === 'Construction' && roles.includes('Approve Construction Timesheets')) ||
        (props.timesheetData?.timesheetType === 'Gravel' && roles.includes('Approve Gravel Timesheets')) || 
        (props.timesheetData?.timesheetType === 'Shop' && roles.includes('Approve Shop Timesheets')) || 
        (props.timesheetData?.timesheetType === 'Snow' && roles.includes('Approve Snow Timesheets'))) &&
        props.timesheetData.submitted;

    const canApprovePayroll = props.timesheetData?.approved && 
        !props.timesheetData?.payrolled && 
        roles.includes('Approve Payroll Timesheets') && 
        props.timesheetData.submitted;

    return (
        <React.Fragment>
            {/* All your existing dialogs remain the same */}
            <Dialog open={splitOpen}>
                <DialogTitle id="alert-dialog-title">{"Split Timesheet?"}</DialogTitle>
                <DialogContent>
                    {!splitting?<DialogContentText id="alert-dialog-description">
                        Are you sure you want to split this timesheet into 2 timesheets?
                    </DialogContentText>:null}
                    {splitting?<DialogContentText id="alert-dialog-description">
                        Please wait... Splitting Timesheet...
                    </DialogContentText>:null}
                    {splitting?<BorderLinearProgress variant="determinate" value={splitProgress} />:null}
                    {splitting?<DialogContentText id="alert-dialog-description"> {splitDescription} </DialogContentText>:null}
                </DialogContent>
                <DialogActions>
                    <Button onClick={()=>handleSplitTimesheet()} disabled={splitting} variant="contained" color="primary" autoFocus>
                        Split
                    </Button>
                    <Button onClick={handleCloseSplit} disabled={splitting} variant="contained" color="secondary">
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={open} onClose={handleClose}>
                <DialogTitle id="alert-dialog-title">{"Delete Timesheet?"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you absolutely sure you want to delete this timesheet? (this will delete all records to this Timesheet!)
                    </DialogContentText>
                    <TextField
                        variant="outlined"
                        autoFocus
                        multiline
                        fullWidth
                        rows={4}
                        margin="dense"
                        value={deleteReason}
                        onChange={(e)=>setDeleteReason(e.target.value)}
                        id="deleteReason"
                        label="Please provide a reason for this deletion."
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} variant="contained" color="secondary">
                        No!
                    </Button>
                    <Button onClick={handleDeleteClick} disabled={deleteReason.length<5} variant="contained" color="primary" autoFocus>
                        Yes!
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={approveOpen} onClose={handleClickApproveClose}>
                <DialogTitle id="alert-dialog-title">
                    {props.timesheetData?.approved ? "Unapprove Timesheet #"+props.timesheetData.timesheetID+' ?' : "Approve Timesheet #"+props.timesheetData.timesheetID+' ?'}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to {props.timesheetData?.approved ? 'unapprove' : 'approve'} this timesheet?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={props.timesheetData?.approved ? () => handleUnapproveClick()  : () => handleApproveClick()} variant="contained" color="primary" autoFocus>
                        {props.timesheetData?.approved ? 'Unapprove' : 'Approve'}
                    </Button>
                    <Button onClick={handleClickApproveClose} variant="contained" color="secondary">
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={approvePayrollOpen} onClose={handleClickApprovePayrollClose}>
                <DialogTitle id="alert-dialog-title">
                    {props.timesheetData?.payrolled ? "Unapprove Timesheet #"+props.timesheetData.timesheetID+' for Payroll?' : "Approve Timesheet #"+props.timesheetData.timesheetID+' for Payroll?'}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to {props.timesheetData?.payrolled ? 'unapprove' : 'approve'} this timesheet for Payroll?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={props.timesheetData?.payrolled ? () => handleUnapproveClickPayroll()  : () => handleApproveClickPayroll()} variant="contained" color="primary" autoFocus>
                        {props.timesheetData?.payrolled ? 'Unapprove' : 'Approve'}
                    </Button>
                    <Button onClick={handleClickApprovePayrollClose} variant="contained" color="secondary">
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>

            <Paper className={classes.headerCard} elevation={0}>
                <div className={`${classes.statusBar} ${getStatusBarClass()}`}>
                    <TimerIcon style={{ fontSize: '20px' }} />
                    <span>
                        {props.timesheetData.timesheetID 
                            ? `Timesheet #${props.timesheetData.timesheetID} - ${getStatus()}`
                            : 'Timesheet in Progress'
                        }
                    </span>
                </div>
                
                <div className={classes.mainContent}>
                    <div className={classes.employeeSection}>
                        <div className={classes.employeeName}>
                            {props.userLoading ? 
                                <Skeleton variant="text" width={200} /> : 
                                props.userData
                            }
                        </div>
                        <div className={classes.metaInfo}>
                            <div className={classes.metaItem}>
                                <span className={classes.metaLabel}>Number</span>
                                <span className={classes.metaValue}>
                                    {props.timesheetData.timesheetID 
                                        ? '#'+props.timesheetData.timesheetID
                                        : 'Timesheet in Progress'
                                    }
                                </span>
                            </div>
                            <div className={classes.metaItem}>
                                <span className={classes.metaLabel}>Type</span>
                                <span className={classes.metaValue}>
                                    {_.isUndefined(props.timesheetData.timesheetType) || props.timesheetData.timesheetType === '' 
                                        ? 'NO TYPE'
                                        : props.timesheetData.timesheetType
                                    }
                                </span>
                            </div>
                            <div className={classes.metaItem}>
                                <span className={classes.metaLabel}>Status</span>
                                <span className={classes.metaValue}>{getStatus()}</span>
                            </div>
                            {props.timesheetData.date && (
                                <div className={classes.metaItem}>
                                    <span className={classes.metaLabel}>Date</span>
                                    <span className={classes.metaValue}>
                                        {moment(props.timesheetData.inTime).format('MMM DD, YYYY')}
                                    </span>
                                </div>
                            )}
                        </div>
                    </div>
                    
                    <div className={classes.actionsSection}>
                        {props.roles.includes("Create|Update|Delete Timesheets") &&
                            <div className={classes.btnGroup}>
                                <Button 
                                    variant='contained'
                                    //className={`${classes.btn} ${classes.btnOutline}`}
                                    onClick={handlePrint}
                                    startIcon={<PrintIcon />}
                                >
                                    Print
                                </Button>
                                
                                {props.timesheetData.submitted ? (
                                    <Button 
                                        variant='contained'
                                        //className={`${classes.btn} ${classes.btnOutline}`}
                                        disabled={props.timesheetData.approved || props.timesheetData.payrolled || props.unsubmitting}
                                        onClick={props.unsubmit}
                                    >
                                        {props.unsubmitting ? 'Unsubmitting...' : 'Unsubmit'}
                                    </Button>
                                ) : (
                                    <Button 
                                        variant='contained'
                                        //className={`${classes.btn} ${classes.btnOutline}`}
                                        disabled={props.timesheetData.approved || props.timesheetData.payrolled || props.submitting}
                                        onClick={props.submitSheet}
                                    >
                                        {props.submitting ? 'Saving...' : 'Submit'}
                                    </Button>
                                )}
                                
                                {canApprove && (
                                    <Button 
                                        variant='contained'
                                        color={'secondary'}
                                        style={(props.timesheetData?.payrolled) ? null : {color:'white', backgroundColor:'green'}}
                                        //className={`${classes.btn} ${props.timesheetData?.approved ? classes.btnOutline : classes.btnSuccess}`}
                                        onClick={handleClickApproveOpen}
                                        startIcon={!props.timesheetData?.approved ? <ThumbUpIcon/> : <ThumbDownIcon/>}
                                    >
                                        {props.timesheetData?.approved ? 'Unapprove' : 'Approve'}
                                    </Button>
                                )}
                                
                                {canApprovePayroll && (
                                    <Button 
                                        variant='contained' 
                                        color={'secondary'}
                                        style={(props.timesheetData?.approved) ? null : {color:'white', backgroundColor:'green'}}
                                        //className={`${classes.btn} ${props.timesheetData?.payrolled ? classes.btnOutline : classes.btnPrimary}`}
                                        onClick={handleClickApprovePayrollOpen}
                                        startIcon={!props.timesheetData?.payrolled ? <ThumbUpIcon/> : <ThumbDownIcon/>}
                                    >
                                        {props.timesheetData?.payrolled ? 'Unapprove Payroll' : 'Approve Payroll'}
                                    </Button>
                                )}
                                
                                <Button 
                                    variant='contained'
                                    style={(props.timesheetData?.approved) ? null : {color:'white', backgroundColor:'red'}}
                                    //className={`${classes.btn} ${classes.btnDanger}`}
                                    onClick={handleClickOpen}
                                    disabled={props.timesheetData?.approved}
                                    startIcon={<DeleteIcon />}
                                >
                                    Delete
                                </Button>
                            </div>
                        }
                        
                        {props.uri && (
                            <div className={classes.qrSection}>
                                <QRCode 
                                    value={`https://geeteeholdings.com/dashboard/reporting/timesheets?docId=${props.timesheetData.docId}`}
                                    size={48}
                                    bgColor="#ffffff"
                                    fgColor="#000000"
                                    level="L"
                                    includeMargin={false}
                                    renderAs="canvas"
                                />
                            </div>
                        )}
                    </div>
                </div>
                
                {props.roles.includes("Create|Update|Delete Timesheets") &&
                <>
                    {/* Warning banners */}
                    {moment() < moment(props.timesheetData.outTime).add(1, 'hours') && (
                        <Box px={4} pb={3}>
                            <div className={classes.warningBanner}>
                                <Typography className={classes.warningText}>
                                    This timesheet can still be modified by the employee until {moment(props.timesheetData.outTime).add(1, 'hours').format('hh:mm a')}.
                                </Typography>
                            </div>
                        </Box>
                    )}
                    
                    {!props.isTimesheetOnSameDate() && (
                        <Box px={4} pb={3}>
                            <div className={classes.warningBanner}>
                                <Typography className={classes.warningText}>
                                    This Timesheet's In Time & Out Time are on 2 different dates.
                                </Typography>
                                <Button
                                    variant="contained" 
                                    color="primary"
                                    size="small"
                                    onClick={handleOpenSplit}
                                >
                                    Split Timesheet
                                </Button>
                            </div>
                        </Box>
                    )}
                </>
                }
            </Paper>
            
            {/* Error message */}
            {props.errorMessage && (
                <Typography color="error" style={{ marginTop: '8px' }}>
                    {props.errorMessage}
                </Typography>
            )}
            
            {/* Alert slide */}
            <Slide direction="down" in={alertOpen} style={{ position: 'sticky', width: '100%' }}>
                <Alert variant="filled" severity={setting === 'unapprove' ? "error" : "success"}>
                    Timesheet #{props.timesheetData.timesheetID} {setting === 'unapprove' ? 'Unapproved' : 'Approved!'}, loading next timesheet...
                </Alert>
            </Slide>
        </React.Fragment>
    )
}

export default withRouter(TimesheetHeader)